export function parseLegacyRoomsRelation(roomsRelation) {
    if (!roomsRelation || Array.isArray(roomsRelation)) {
        return {};
    }
    return roomsRelation;
}
function getNormalizedUnitId({ room_type_id, room_id, }) {
    if (!room_type_id || !room_id)
        return undefined;
    return `${room_type_id}-${room_id}`;
}
/**
 * Cleans the split inventory by removing children entries that are not available
 * (i.e., their room IDs are not present in the accommodations returned by the API).
 * It also removes parent entries that end up with no valid children.
 */
export function cleanUnavailableSplitInventoryEntries(splitInventory, rawAccommodations = []) {
    const availableIds = rawAccommodations
        .filter((a) => a.num_available_now > 0)
        .map((a) => a.room_type_id);
    return splitInventory
        .map((item) => (Object.assign(Object.assign({}, item), { children: item.children.filter((child) => availableIds.includes(child.roomId)) })))
        .filter((item) => item.children.length > 0);
}
export function parseSplitInventory(rawSplitInventory, rawAccommodations = []) {
    if (!rawSplitInventory || !rawSplitInventory.links)
        return [];
    const splitInventory = [];
    // loop through the links, each link represents a shared inventory relationship
    rawSplitInventory.links.forEach((link) => {
        // get the root room of the link
        const rootRoomLinkDef = rawSplitInventory.rmTypes.find((rmType) => rmType.level === '0' && rmType.link_id === link.id);
        const rootRoom = rawSplitInventory.rooms.find((x) => x.rm_type_link === (rootRoomLinkDef === null || rootRoomLinkDef === void 0 ? void 0 : rootRoomLinkDef.id));
        if (!rootRoomLinkDef || !rootRoom)
            return;
        const sharedItem = {
            children: [],
            roomId: rootRoom.room_type_id,
            unitId: getNormalizedUnitId(rootRoom),
        };
        // Add the other rooms in the link as children of the root room
        const childrenLinkDef = rawSplitInventory.rmTypes.filter((x) => x.link_id === link.id && x.level !== '0');
        const availableRoomIds = rawAccommodations
            .filter((x) => x.num_available_now > 0)
            .map((x) => x.room_type_id);
        childrenLinkDef.forEach((childLinkDef) => {
            const childRooms = rawSplitInventory.rooms
                .filter((x) => availableRoomIds.includes(x.room_type_id) &&
                x.rm_type_link === childLinkDef.id)
                .map((x) => ({
                roomId: x.room_type_id,
                unitId: getNormalizedUnitId(x),
            }));
            sharedItem.children.push(...childRooms);
        });
        // Only include on the list of shared inventory entries with valid children
        if (sharedItem.children.length) {
            splitInventory.push(sharedItem);
        }
    });
    return cleanUnavailableSplitInventoryEntries(splitInventory, rawAccommodations);
}
